import type { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { select } from "redux-saga/effects";

import type { RootState } from "../store";

import { handleSagaError } from "./handleSagaError";

export interface ApplySagaErrorOptions<TPayload> {
  operationName: string;
  endpoint?: string;
  failureAction?: ActionCreatorWithPayload<TPayload>;
  captureInSentry?: boolean;
  critical?: boolean;
  notifyUser?: boolean;
  expectedHttpStatuses?: number[];
  sentryContext?: Record<string, unknown>;
  captureStoreSnapshot?: boolean;
  storeSnapshotSelector?: (state: RootState) => unknown;
}



export function* applySagaError<TPayload>(
  error: unknown,
  {
    operationName,
    endpoint,
    failureAction,
    captureInSentry = true,
    critical,
    notifyUser,
    expectedHttpStatuses,
    sentryContext,
    captureStoreSnapshot,
    storeSnapshotSelector = (state: RootState) => state,
  }: ApplySagaErrorOptions<TPayload>,
): Generator<unknown, void, unknown> {
  let finalSentryContext = sentryContext;

  if (captureInSentry && captureStoreSnapshot) {
    const store = yield select(storeSnapshotSelector);
    finalSentryContext = { store, ...finalSentryContext };
  }

  yield* handleSagaError(
    error,
    {
      operationName,
      endpoint,
      critical,
      notifyUser,
      expectedHttpStatuses,
    },
    failureAction,
    captureInSentry,
    finalSentryContext,
  );
}
